//helper functions to get user info from session storage.
export const getUser = () => {
  const user = sessionStorage.getItem("user");
  return user ? JSON.parse(user) : null;
};

export const getRole = () => {
  const user = getUser();
  return user?.role || null;
};

export const hasRole = (...roles) => {
  const role = getRole();
  return roles.includes(role);
};